
import { getImageByPosition } from "~/utils";

export default {
  name: "QuizListBlock",
  props: {
    quizListItems: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    blockResults: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    getImageByPosition,
    onEntityClick(item) {
      this.$emit("onSelect", { type: this.data.type, item });
    },
  },
};
